import * as React from "react";
import CategoriesNestedContainer from "../../BillerCategories/CategoriesNestedContainer";
import AssociatedBillersContainer from "../../BillerCategories/AssociatedBillersContainer";
import TopBar from "./Ops.BillerCategories.GeneralTopBar";
import { match } from "react-router-dom";
import { graphql, compose } from "react-apollo";
import gql from "graphql-tag";
import { Category } from "../../BillerCategories/billerCategoryTypes";

type State = {
  categoryTree: Array<Category>;
};

type Props = {
  match: match<{ ref: string }>;
  setHeader: (data: { title: string; description: string }) => void;
  data: any;
  getAssociatedBillers?: any;
};

class Summary extends React.Component<Props, State> {
  state = { categoryTree: [] };
  componentDidMount() {
    this.props.setHeader({
      title: "Ops > BillerCategories",
      description: "SnapScan Categories",
    });
  }

  didSelectCategory = (category: Category) => {
    this.props.getAssociatedBillers.refetch({
      external_reference: category.external_reference,
      skip: false,
    });
  };

  getBillersFromProps = () => {
    const cats = this.props.getAssociatedBillers.categories;
    return !!cats && cats.length > 0 ? cats[0].associated_billers : [];
  };

  render() {
    return (
      <React.Fragment>
        <TopBar />
        <section
          className="scrollable"
          style={{ display: "flex", flexDirection: "row" }}
        >
          <div style={{ flex: "0 0 70%" }}>
            <CategoriesNestedContainer
              onSelect={this.didSelectCategory}
              categories={this.props.data.categories}
            />
          </div>
          <div style={{ flex: "0 0 auto", width: "30%" }}>
            <div
              style={{
                display: "flex",
                flex: "1 0 auto",
                flexDirection: "column",
                position: "fixed",
                height: "100%",
                overflowY: "auto",
                minWidth: "100%",
                backgroundColor: "#ebebeb",
              }}
            >
              <AssociatedBillersContainer
                billers={this.getBillersFromProps()}
              />
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

const topCategoriesQuery = graphql<any, Props>(
  gql`
    query topCategoriesQuery {
      categories(top_level: true, offset: 0, limit: 100) {
        id
        external_reference
        icon
        updated_at
        name
        sub_categories {
          id
          external_reference
          icon
          updated_at
          name
          sub_categories {
            id
            external_reference
            icon
            updated_at
            name
          }
        }
      }
    }
  `
);

const getBillersQuery = graphql<any, Props>(
  gql`
    query getBillersQuery($external_reference: ID, $skip: Boolean!) {
      categories(external_reference: $external_reference, offset: 0, limit: 1)
        @skip(if: $skip) {
        id
        name
        associated_billers {
          id
          identifier
          provider
          name
          placeholder
          logo
          updated_at
        }
      }
    }
  `,
  {
    name: "getAssociatedBillers",
    options(props: any) {
      return {
        variables: {
          external_reference: props.external_reference,
          skip: true,
        },
      };
    },
  }
);

export default compose<any>(topCategoriesQuery, getBillersQuery)(Summary);
